module.exports = "<div asui-well>\n    <div class=\"flex\">\n        <div class=\"flex-4\">\n            <label class=\"modalLabel\">{{$ctrl.label}}</label>\n        </div>\n        <div class=\"flex-3\">\n           <span class=\"marginLeft10\"> {{$ctrl.subscription}} </span>\n        </div>\n\n        <div class=\"flex-1 right\">\n           <span class=\"modalFontGrey \"  ng-show=\"$ctrl.perpetual > 0\">\n                  includes {{$ctrl.perpetual}} preassigned perpetual\n                \n        </span>\n        </div>\n    </div>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./modules/license/features/license-id-detail/licenseIdDetail.component.html
// module id = 557
// module chunks = 0